import {Component} from 'react'
import {Link} from 'react-router-dom'
import Cookies from 'js-cookie'

import ThemeContext from '../../context/ThemeContext'
import './index.css'

class SavedVideos extends Component {
  state = {
    savedVideos: [],
  }

  componentDidMount() {
    this.getSavedVideos()
  }

  getSavedVideos = () => {
    try {
      const savedVideosData = Cookies.get('saved_videos')
      const savedVideos = savedVideosData ? JSON.parse(savedVideosData) : []
      this.setState({savedVideos})
    } catch (e) {
      this.setState({savedVideos: []})
    }
  }

  renderEmptyView = isDarkTheme => {
    const headingColor = isDarkTheme
      ? 'empty-heading-dark'
      : 'empty-heading-light'
    const textColor = isDarkTheme ? 'empty-text-dark' : 'empty-text-light'

    return (
      <div className="saved-empty-view" data-testid="savedVideos">
        <img
          src="https://assets.ccbp.in/frontend/react-js/nxt-watch-no-saved-videos-img.png"
          alt="no saved videos"
          className="saved-empty-img"
        />
        <h1 className={headingColor}>No saved videos found</h1>
        <p className={textColor}>
          You can save your videos while watching them
        </p>
      </div>
    )
  }

  renderVideosListView = isDarkTheme => {
    const {savedVideos} = this.state
    const textColor = isDarkTheme ? 'video-text-dark' : 'video-text-light'
    const headingColor = isDarkTheme ? 'heading-dark' : 'heading-light'

    return (
      <div className="saved-videos-container" data-testid="savedVideos">
        <div className="saved-videos-header">
          <div className="saved-videos-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M17 3H7C5.9 3 5 3.9 5 5V19L12 15.5L19 19V5C19 3.9 18.1 3 17 3Z"
                fill="#ff0b37"
              />
            </svg>
          </div>
          <h1 className={headingColor}>Saved Videos</h1>
        </div>
        <ul className="saved-videos-list">
          {savedVideos.map(video => (
            <li key={video.id} className="saved-video-item">
              <Link to={`/videos/${video.id}`} className="saved-video-link">
                <img
                  src={video.thumbnailUrl}
                  alt="video thumbnail"
                  className="saved-video-thumbnail"
                />
                <div className="saved-video-details">
                  <p className={`saved-video-title ${textColor}`}>
                    {video.title}
                  </p>
                  <p className={`saved-channel-name ${textColor}`}>
                    {video.channelName}
                  </p>
                  <p className={`saved-video-stats ${textColor}`}>
                    {video.viewCount} views • {video.publishedAt}
                  </p>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    )
  }

  render() {
    const {savedVideos} = this.state

    return (
      <ThemeContext.Consumer>
        {value => {
          const {isDarkTheme, toggleTheme} = value

          const logoUrl = isDarkTheme
            ? 'https://assets.ccbp.in/frontend/react-js/nxt-watch-logo-light-theme-img.png'
            : 'https://assets.ccbp.in/frontend/react-js/nxt-watch-logo-dark-theme-img.png'

          const containerBgColor = isDarkTheme
            ? 'saved-container-dark'
            : 'saved-container-light'
          const navBgColor = isDarkTheme ? 'nav-dark' : 'nav-light'

          return (
            <div className={`saved-videos-page ${containerBgColor}`}>
              <header className="saved-header">
                <Link to="/">
                  <img
                    src={logoUrl}
                    alt="website logo"
                    className="website-logo"
                  />
                </Link>
                <button
                  type="button"
                  data-testid="theme"
                  onClick={toggleTheme}
                  className="theme-button"
                >
                  {isDarkTheme ? '🌞' : '🌙'}
                </button>
              </header>

              <div className="saved-body">
                <nav className={`saved-sidebar ${navBgColor}`}>
                  <ul className="nav-menu">
                    <li>
                      <Link to="/" className="nav-link">
                        Home
                      </Link>
                    </li>
                    <li>
                      <Link to="/trending" className="nav-link">
                        Trending
                      </Link>
                    </li>
                    <li>
                      <Link to="/gaming" className="nav-link">
                        Gaming
                      </Link>
                    </li>
                    <li>
                      <Link to="/saved-videos" className="nav-link active">
                        Saved Videos
                      </Link>
                    </li>
                  </ul>
                </nav>

                <main className="saved-main-content">
                  {savedVideos.length === 0
                    ? this.renderEmptyView(isDarkTheme)
                    : this.renderVideosListView(isDarkTheme)}
                </main>
              </div>
            </div>
          )
        }}
      </ThemeContext.Consumer>
    )
  }
}

export default SavedVideos
